import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import DetailIcon from '../../components/Table/DetailIcon/DetailIcon';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
const pageKey = "recipientgroup"


const GroupRecipient = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedGroupArchiveAction, setSelectedGroupArchiveAction] = useState('');
  const [items, setItems] = useState([]);
  const [archivedGroups, setArchivedGroups] = useState(new Set());
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const navigate = useNavigate();
  const [exportState, setExportState] = useState({
    isExporting: false,
    error: null
  });


  useEffect(() => {
    

    fetchRecipientGroups();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]);

  const fetchRecipientGroups = async () => {
    try {
      const params = {
        search: searchParams.term,
        filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
        sort: mapSortOptionToQuery(selectedSortOption),
      };
      
      const response = await authenticatedAxios.get(`${baseurl}notifications/recipient-groups/`, { params });
      if (response.data.response_code === 1) {
        setItems(response.data.data); 
        const archivedSet = new Set(response.data.data.filter(group => group.is_archived).map(group => group.id));
        setArchivedGroups(archivedSet);
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching recipient groups:', error);
      }
    }
  };
  

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}notifications/recipient-groups/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchRecipientGroups();
        resetCheckboxState(); 
        closePopups();
      } 
    } catch (error) {
      
    }
  };


  const handleArchive = async () => {
    try {
      const response = await authenticatedAxios.get(
        `${baseurl}notifications/recipient-groups/archive/?id=${selectedItem.id}`
      );
      if (response.status >= 200 && response.status < 300) {
        closePopups();
        fetchRecipientGroups();
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error('Error archiving plan:', error);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}notifications/recipient-groups/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchRecipientGroups(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error('Error deleting plan:', error);
    }
  };
  

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };
  
  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };


  const handleArchiveClick = async (item) => {
    try {
      const action = item.is_archived ? 'unarchive' : 'archive';
      await authenticatedAxios.post(`${baseurl}notifications/recipient-groups/${action}/`, {
        id: item.id,
      });
      fetchRecipientGroups();
    } catch (error) {
      console.error('Error toggling archive status:', error);
    }
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };
  
  const handleAddClick = () => {
    navigate('/add-recipient');
    navigate('/add-recipient');
  };

  const handleDetailClick = (item) => {
    navigate('/detail-recipient', { state: { item } });
  };

  const handleEditClick = (item) => {
    navigate('/edit-recipient', { state: { item } });
    
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsDeletePopupOpen(false);
    setIsNewPopupOpen(false);
    setSelectedItem([]);
  };


  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];

  const editPopupFields = [
    { label: 'State Name', type: 'large-input', defaultValue: selectedItem?.name || '', onChange: () => {} },
    { label: 'State Code', type: 'large-input', defaultValue: selectedItem?.code || '', onChange: () => {} },
    { label: 'Country', type: 'large-select', options: [{ label: 'India', value: 'India' }, { label: 'England', value: 'England' }], defaultValue: selectedItem?.country || '', onChange: () => {} },
  ];

  const handleExportStart = () => {
    setExportState({ isExporting: true, error: null });
  };

  const handleExportComplete = () => {
    setExportState({ isExporting: false, error: null });
    resetCheckboxState();
  };

  const handleExportError = (error) => {
    setExportState({ isExporting: false, error });
  };


  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName=" Notifications /" nestedpageName="Recipient Groups"  linkTo="/notification-list" /> 
        <div className='export-container'>
          <ArchiveSelectedItem
            selectedItems={selectedItems}
            items={items}
            onArchiveSelected={handleArchiveSelectedItems}
          />
          <ExportLabel
            exportUrl={`${baseurl}notifications/recipient-groups/export/`}
            selectedIds={selectedItems}
            onExportStart={handleExportStart}
            onExportComplete={handleExportComplete}
            onExportError={handleExportError}
          />
        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Recipient Groups</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleAddClick} />
          <SimpleSearchBox placeholder="Search Groups" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Group Name
              </th>
              <th>Number of customers</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
            {items.length > 0 ? (
              items.map((group) => (
              <tr key={group.id} className={group.is_archived ? 'archived-item' : ''}>
                <td>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(group.id)}
                    onChange={() => handleChildCheckboxChange(group.id)}
                  />{group.name}
                </td>
                <td>{ group.recipients.length }</td>
                <td>
                  {(() => {
                    const date = new Date(group.created_time);
                    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
                  })()}
                </td>

                <td className="actions common-action">
                  <DetailIcon onClick={() => handleDetailClick(group)} />
                  <EditIcon onClick={() => handleEditClick(group)} />
                  {archivedGroups.has(group.id) ? (
                    // <UnarchiveIcon onClick={() => handleArchiveClick(group)} />
                    <ArchiveIcon onClick={() => handleArchiveClick(group)} isArchived={group.is_archived}/>
                  ) : (
                    <ArchiveIcon onClick={() => handleArchiveClick(group)} isArchived={group.is_archived} />
                  )}

                  {/* <ArchiveIcon onClick={() => handleArchiveClick(group)} /> */}
                  <DeleteIcon onClick={() => handleDeleteClick(group)} />
                </td>
              </tr>
            ))
            ):(
              <tr>
                <td colSpan="6">
                    No Recipient Group Available
                </td>
              </tr>
          )}
          </tbody>
        </table>
      </div>

      {/* <EditPopup
        isOpen={isEditPopupOpen}
        title="Edit Recipient Group"
        fields={editPopupFields}
        onSave={closePopups}
        onClose={closePopups}
      /> */}

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Recipient Group"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />

      
      {/* <AddPopup
        isOpen={isNewPopupOpen}
        title="New Recipient Group"
        fields={addPopupFields}
        onSave={handleAddClick}
        onClose={closePopups}
      /> */}
     
    </div>
  );
};

export default GroupRecipient;